/** Decode entities like &lt;p&gt; then strip tags for plain-text inputs. */
export function decodeHtmlEntities(html: string): string {
    if (!html) return '';
    if (typeof document === 'undefined') {
        return html
            .replace(/&lt;/gi, '<')
            .replace(/&gt;/gi, '>')
            .replace(/&amp;/gi, '&')
            .replace(/&quot;/gi, '"')
            .replace(/&#39;/gi, "'");
    }
    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value;
}

export function plainTextFromHtml(html: string): string {
    const decoded = decodeHtmlEntities(html);
    return decoded
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

export function htmlLooksLikeMarkup(html: string): boolean {
    const decoded = decodeHtmlEntities(html);
    return /<[a-z][\s\S]*>/i.test(decoded);
}

/** Decode entity-encoded HTML (`&lt;p&gt;`) so Quill renders markup instead of raw tags. */
export function normalizeRichTextForEditor(html: string): string {
    if (!html) return '';
    if (html.includes('&lt;') || html.includes('&gt;') || html.includes('&amp;')) {
        return decodeHtmlEntities(html);
    }
    return html;
}
